import { atom, useAtomValue } from 'jotai';

export const mailboxSyncInProgressAtom = atom(false);

export const useIsMailboxSyncInProgress = (): boolean => useAtomValue(mailboxSyncInProgressAtom);
